// removed by extract-text-webpack-plugin
module.exports = {"lineItem":"_14EF30S5PhCNyUZUPy8TIi","lineItem__details":"_3FxvbqBuI8URxSsup7e4Za","lineItem__image":"B9RjrtpMSwFkynvEysM4K","lineItem__detail":"p29Sv-OVFMyqFATjGcB5h","lineItem__name":"_2PYSYyRQHzc52VA4IRjr6E","lineItem__color":"_2brraMtpK_hUfn5F9Lh2dk","lineItem__options":"_1_j1wTGi9fQkL2guwWxZvz","lineItem__quantity":"_2NG8mqPQWBCPC0Y0bTWcc5","lineItem__quantitySelect":"_3i1RMYPsrn4PVoevpzBEZF","lineItem__remove":"_1QolU3AbUsSaEb1J3MeQnG","lineItem__price":"_4Va4KIC9Ot0pAyZx47Uc8","lineItem__pricePerItem-row":"_31KE2HIpmVFYH7k4lweRib"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/LineItem/style.scss
// module id = 892
// module chunks = 0